import React from 'react';
import { useTranslation } from 'react-i18next';

const Terms: React.FC = () => {
  const { t } = useTranslation('legal');

  return (
    <div className="max-w-4xl mx-auto px-4 py-12 min-h-[calc(100vh-200px)]">
      {/* Meta */}
      <div className="flex items-start justify-between mb-4">
        <h1 className="text-3xl font-bold">{t('terms.title')}</h1>
        <div className="text-right">
          <span className="inline-block bg-gray-100 text-gray-700 text-xs px-2 py-1 rounded mr-2">{t('terms.lastUpdated')}</span>
          <span className="inline-block bg-gray-100 text-gray-700 text-xs px-2 py-1 rounded">{t('terms.version')}</span>
        </div>
      </div>

      {/* Key Points */}
      <div className="border border-gray-200 rounded-lg p-4 mb-6">
        <h2 className="text-sm font-semibold text-gray-900 mb-2">{t('terms.keyPoints.title')}</h2>
        <ul className="list-disc pl-6 text-sm text-gray-700 space-y-1">
          <li>{t('terms.keyPoints.item1')}</li>
          <li>{t('terms.keyPoints.item2')}</li>
          <li>{t('terms.keyPoints.item3')}</li>
          <li>{t('terms.keyPoints.item4')}</li>
          <li>{t('terms.keyPoints.item5')}</li>
          <li>{t('terms.keyPoints.item6')}</li>
          <li>{t('terms.keyPoints.item7')}</li>
          <li>{t('terms.keyPoints.item8')}</li>
          <li>{t('terms.keyPoints.item9')}</li>
          <li>{t('terms.keyPoints.item10')}</li>
          <li>{t('terms.keyPoints.item11')}</li>
          <li>{t('terms.keyPoints.item12')}</li>
          <li>{t('terms.keyPoints.item13')}</li>
          <li>{t('terms.keyPoints.item14')}</li>
          <li>{t('terms.keyPoints.item15')}</li>
          <li>{t('terms.keyPoints.item16')}</li>
          <li>{t('terms.keyPoints.item17')}</li>
          <li>{t('terms.keyPoints.item18')}</li>
          <li>{t('terms.keyPoints.item19')}</li>
          <li>{t('terms.keyPoints.item20')}</li>
          <li>{t('terms.keyPoints.item21')}</li>
        </ul>
      </div>

      {/* TOC */}
      <div className="bg-gray-50 border border-gray-200 rounded-lg p-4 mb-8">
        <h2 className="text-sm font-semibold text-gray-900 mb-2">{t('terms.toc.title')}</h2>
        <ol className="list-decimal pl-5 text-sm text-gray-800 space-y-1">
          <li><a className="hover:underline" href="#sec1">{t('terms.toc.sec1')}</a></li>
          <li><a className="hover:underline" href="#sec2">{t('terms.toc.sec2')}</a></li>
          <li><a className="hover:underline" href="#sec3">{t('terms.toc.sec3')}</a></li>
          <li><a className="hover:underline" href="#sec4">{t('terms.toc.sec4')}</a></li>
          <li><a className="hover:underline" href="#sec5">{t('terms.toc.sec5')}</a></li>
          <li><a className="hover:underline" href="#sec6">{t('terms.toc.sec6')}</a></li>
          <li><a className="hover:underline" href="#sec7">{t('terms.toc.sec7')}</a></li>
          <li><a className="hover:underline" href="#sec8">{t('terms.toc.sec8')}</a></li>
          <li><a className="hover:underline" href="#sec9">{t('terms.toc.sec9')}</a></li>
          <li><a className="hover:underline" href="#sec10">{t('terms.toc.sec10')}</a></li>
          <li><a className="hover:underline" href="#sec11">{t('terms.toc.sec11')}</a></li>
          <li><a className="hover:underline" href="#sec12">{t('terms.toc.sec12')}</a></li>
          <li><a className="hover:underline" href="#sec13">{t('terms.toc.sec13')}</a></li>
          <li><a className="hover:underline" href="#sec14">{t('terms.toc.sec14')}</a></li>
          <li><a className="hover:underline" href="#sec15">{t('terms.toc.sec15')}</a></li>
        </ol>
      </div>

      <h2 id="sec1" className="text-xl font-semibold mt-6 mb-2">{t('terms.sec1.title')}</h2>
      <p className="text-gray-700">{t('terms.sec1.text')}</p>
      <p className="text-gray-700 mt-4 font-medium">{t('terms.sec1.contractingParty')}</p>
      <p className="text-gray-700 mt-4">{t('terms.sec1.platformRole')}</p>

      <h2 id="sec2" className="text-xl font-semibold mt-6 mb-2">{t('terms.sec2.title')}</h2>
      <ul className="list-disc pl-6 text-gray-700 space-y-2">
        <li>{t('terms.sec2.item1')}</li>
        <li>{t('terms.sec2.item2')}</li>
        <li>{t('terms.sec2.item3')}</li>
        <li>{t('terms.sec2.item4')}</li>
        <li>{t('terms.sec2.item5')}</li>
        <li>{t('terms.sec2.item6')}</li>
        <li>{t('terms.sec2.item7')}</li>
        <li>{t('terms.sec2.item8')}</li>
        <li>{t('terms.sec2.item9')}</li>
        <li>{t('terms.sec2.item10')}</li>
        <li>{t('terms.sec2.item11')}</li>
        <li>{t('terms.sec2.item12')}</li>
        <li>{t('terms.sec2.item13')}</li>
        <li>{t('terms.sec2.item14')}</li>
        <li>{t('terms.sec2.item15')}</li>
        <li>{t('terms.sec2.item16')}</li>
        <li>{t('terms.sec2.item17')}</li>
        <li>{t('terms.sec2.item18')}</li>
      </ul>

      <h2 id="sec3" className="text-xl font-semibold mt-6 mb-2">{t('terms.sec3.title')}</h2>
      <p className="text-gray-700">{t('terms.sec3.text')}</p>

      <h2 id="sec4" className="text-xl font-semibold mt-6 mb-2">{t('terms.sec4.title')}</h2>
      <p className="text-gray-700">{t('terms.sec4.text')}</p>

      <h2 id="sec5" className="text-xl font-semibold mt-6 mb-2">{t('terms.sec5.title')}</h2>
      <p className="text-gray-700">{t('terms.sec5.text')}</p>
      <p className="text-gray-700 mt-4 italic">{t('terms.sec5.userContent')}</p>
      <p className="text-gray-700 mt-4 italic">{t('terms.sec5.anonymizationRight')}</p>
      <p className="text-gray-700 mt-4 italic">{t('terms.sec5.communityModeration')}</p>

      <h2 id="sec6" className="text-xl font-semibold mt-6 mb-2">{t('terms.sec6.title')}</h2>
      <p className="text-gray-700">{t('terms.sec6.text')}</p>
      <p className="text-gray-700 mt-4 italic font-semibold">{t('terms.sec6.betaStatus')}</p>
      <p className="text-gray-700 mt-4 italic">{t('terms.sec6.aiDisclaimer')}</p>
      <p className="text-gray-700 mt-4 italic">{t('terms.sec6.veeTalksDisclaimer')}</p>
      <p className="text-gray-700 mt-4 italic">{t('terms.sec6.candidateAnalysisDisclaimer')}</p>
      <p className="text-gray-700 mt-4 italic">{t('terms.sec6.forceMajeure')}</p>
      <p className="text-gray-700 mt-4 italic">{t('terms.sec6.userContentDisclaimer')}</p>
      <p className="text-gray-700 mt-4 italic">{t('terms.sec6.intermediaryDisclaimer')}</p>
      <p className="text-gray-700 mt-4 italic">{t('terms.sec6.realTalkDisclaimer')}</p>
      <p className="text-gray-700 mt-4 italic">{t('terms.sec6.creatorContentDisclaimer')}</p>
      <p className="text-gray-700 mt-4 italic">{t('terms.sec6.klipyDisclaimer')}</p>
      <p className="text-gray-700 mt-4 italic">{t('terms.sec6.communityDisclaimer')}</p>
      <p className="text-gray-700 mt-4 italic">{t('terms.sec6.appDisclaimer')}</p>

      <h2 id="sec7" className="text-xl font-semibold mt-6 mb-2">{t('terms.sec7.title')}</h2>
      <p className="text-gray-700">{t('terms.sec7.text')}</p>
      <p className="text-gray-700 mt-4 italic">{t('terms.sec7.termination')}</p>

      <h2 id="sec8" className="text-xl font-semibold mt-6 mb-2">{t('terms.sec8.title')}</h2>
      <p className="text-gray-700">{t('terms.sec8.intro')}</p>
      <p className="text-gray-700 mt-4">{t('terms.sec8.plans')}</p>
      <p className="text-gray-700 mt-4"><strong>{t('terms.sec8.recruiterModelLabel')}</strong> {t('terms.sec8.recruiterModel')}</p>
      <p className="text-gray-700 mt-4 italic">{t('terms.sec8.legacyPlansNote')}</p>
      <p className="text-gray-700 mt-4">{t('terms.sec8.payment')}</p>
      <p className="text-gray-700 mt-4">{t('terms.sec8.renewal')}</p>
      <p className="text-gray-700 mt-4">{t('terms.sec8.cancellation')}</p>
      <p className="text-gray-700 mt-4"><strong>{t('terms.sec8.refundPolicyLabel')}</strong> {t('terms.sec8.noRefunds')}</p>
      <p className="text-gray-700 mt-4">{t('terms.sec8.priceChanges')}</p>
      <p className="text-gray-700 mt-4"><strong>{t('terms.sec8.failedPaymentsLabel')}</strong> {t('terms.sec8.failedPayments')}</p>
      <p className="text-gray-700 mt-4"><strong>{t('terms.sec8.disputesLabel')}</strong> {t('terms.sec8.disputes')}</p>
      <h3 className="text-lg font-semibold mt-6 mb-2">{t('terms.sec8.withdrawal.title')}</h3>
      <p className="text-gray-700">{t('terms.sec8.withdrawal.right')}</p>
      <p className="text-gray-700 mt-4">{t('terms.sec8.withdrawal.period')}</p>
      <p className="text-gray-700 mt-4">{t('terms.sec8.withdrawal.howTo')}</p>
      <p className="text-gray-700 mt-4">{t('terms.sec8.withdrawal.effects')}</p>
      <p className="text-gray-700 mt-4 italic">{t('terms.sec8.withdrawal.lossOfRight')}</p>
      <p className="text-gray-700 mt-4 font-semibold">{t('terms.sec8.withdrawal.immediateAccess')}</p>
      <p className="text-gray-700 mt-4">{t('terms.sec8.dataProcessing')}</p>

      <h2 id="sec9" className="text-xl font-semibold mt-6 mb-2">{t('terms.sec9.title')}</h2>
      <p className="text-gray-700">{t('terms.sec9.text')}</p>

      <h2 id="sec10" className="text-xl font-semibold mt-6 mb-2">{t('terms.sec10.title')}</h2>
      <p className="text-gray-700">{t('terms.sec10.intro')}</p>
      <p className="text-gray-700 mt-4">{t('terms.sec10.creatorAgreement')}</p>
      <p className="text-gray-700 mt-4">{t('terms.sec10.platformRole')}</p>
      <p className="text-gray-700 mt-4">{t('terms.sec10.userObligations')}</p>
      <p className="text-gray-700 mt-4 italic">{t('terms.sec10.noLiability')}</p>

      <h2 id="sec11" className="text-xl font-semibold mt-6 mb-2">{t('terms.sec11.title')}</h2>
      <p className="text-gray-700">{t('terms.sec11.companyPages')}</p>
      <p className="text-gray-700 mt-4">{t('terms.sec11.interestSignals')}</p>
      <p className="text-gray-700 mt-4">{t('terms.sec11.proactiveSharing')}</p>
      <p className="text-gray-700 mt-4">{t('terms.sec11.spotlights')}</p>
      <p className="text-gray-700 mt-4">{t('terms.sec11.atsUserConsent')}</p>
      <p className="text-gray-700 mt-4">{t('terms.sec11.atsRecruiterDuties')}</p>
      <p className="text-gray-700 mt-4">{t('terms.sec11.atsThirdPartyResponsibility')}</p>
      <p className="text-gray-700 mt-4">{t('terms.sec11.publicContent')}</p>
      <p className="text-gray-700 mt-4 italic">{t('terms.sec11.noLiability')}</p>

      <h2 id="sec12" className="text-xl font-semibold mt-6 mb-2">{t('terms.sec12.title')}</h2>
      <p className="text-gray-700">{t('terms.sec12.intro')}</p>
      <p className="text-gray-700 mt-4"><strong>{t('terms.sec12.recruiterDuties')}</strong></p>
      <p className="text-gray-700 mt-4">{t('terms.sec12.candidateRights')}</p>
      <p className="text-gray-700 mt-4 italic">{t('terms.sec12.aiDisclaimer')}</p>
      <p className="text-gray-700 mt-4">{t('terms.sec12.recording')}</p>
      <p className="text-gray-700 mt-4">{t('terms.sec12.screenShare')}</p>
      <p className="text-gray-700 mt-4">{t('terms.sec12.fairness')}</p>
      <p className="text-gray-700 mt-4">{t('terms.sec12.euAiAct')}</p>
      <p className="text-gray-700 mt-4">{t('terms.sec12.recruiterDemo')}</p>
      <p className="text-gray-700 mt-4 italic">{t('terms.sec12.termination')}</p>

      <h2 id="sec13" className="text-xl font-semibold mt-6 mb-2">{t('terms.sec13.title')}</h2>
      <p className="text-gray-700">{t('terms.sec13.intro')}</p>
      <p className="text-gray-700 mt-4"><strong>{t('terms.sec13.noAffiliation')}</strong></p>
      <p className="text-gray-700 mt-4">{t('terms.sec13.ownContent')}</p>
      <p className="text-gray-700 mt-4">{t('terms.sec13.trademarks')}</p>
      <p className="text-gray-700 mt-4 italic">{t('terms.sec13.noWarranty')}</p>

      <h2 id="sec14" className="text-xl font-semibold mt-6 mb-2">{t('terms.sec14.title')}</h2>
      <p className="text-gray-700">{t('terms.sec14.intro')}</p>
      <p className="text-gray-700 mt-4"><strong>{t('terms.sec14.role')}</strong></p>
      <p className="text-gray-700 mt-4">{t('terms.sec14.consent')}</p>
      <p className="text-gray-700 mt-4">{t('terms.sec14.access')}</p>
      <p className="text-gray-700 mt-4">{t('terms.sec14.retention')}</p>
      <p className="text-gray-700 mt-4">{t('terms.sec14.prescreen')}</p>
      <p className="text-gray-700 mt-4">{t('terms.sec14.noTraining')}</p>
      <p className="text-gray-700 mt-4">{t('terms.sec14.quota')}</p>
      <p className="text-gray-700 mt-4 italic">{t('terms.sec14.noWarranty')}</p>

      <h2 id="sec15" className="text-xl font-semibold mt-6 mb-2">{t('terms.sec15.title')}</h2>
      <p className="text-gray-700">{t('terms.sec15.intro')}</p>
      <p className="text-gray-700 mt-4">{t('terms.sec15.thirdParty')}</p>
      <p className="text-gray-700 mt-4">{t('terms.sec15.employerRemoval')}</p>
      <p className="text-gray-700 mt-4">{t('terms.sec15.matching')}</p>
      <p className="text-gray-700 mt-4">{t('terms.sec15.fairUse')}</p>
      <p className="text-gray-700 mt-4">{t('terms.sec15.interested')}</p>

      <div className="text-gray-600 mt-8">{t('terms.footer')}</div>
    </div>
  );
};

export default Terms;
